module.exports = __webpack_public_path__ + "img/alzaad.3af2f851.png";